// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Environment$Catalyst from "../entities/Environment.bs.js";

function getHostName(param) {
  var match = process.env.NODE_ENV;
  if (match === "development") {
    return "http://localhost:3000";
  } else {
    return process.env.OMS_URL;
  }
}

function getWorkingEnv(param) {
  return Environment$Catalyst.fromString(process.env.NODE_ENV);
}

export {
  getHostName ,
  getWorkingEnv ,
  
}
/* No side effect */
